/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PageTitle {
  title: string;
  count?: number;
  icon?: React.ReactNode;
  subscribersConnectors?: {
    userConnecters?: number;
    companyConnecterLimit?: number;
  };
}

// Initial state
const initialState: PageTitle = {
  title: '',
  count: undefined,
  icon: null,
  subscribersConnectors: undefined,
};

export const PageTitleSlice = createSlice({
  name: 'page-title',
  initialState,
  reducers: {
    /**
     * Function to change page title
     * @param state
     * @param action
     */
    setPageTitle: (state, action: PayloadAction<string | PageTitle>) => {
      if (typeof action.payload === 'string') {
        state.title = action.payload;
        state.count = undefined;
        state.icon = null;
        state.subscribersConnectors = undefined;
      } else {
        state.title = action.payload.title;
        state.count = action.payload.count;
        state.icon = action.payload.icon;
        state.subscribersConnectors = action.payload.subscribersConnectors;
      }
    },
  },
});

// Export the reducer
export const { setPageTitle } = PageTitleSlice.actions;

export default PageTitleSlice.reducer;
